import { DevRouteName } from './model.js';

const routesDev = [
    {
        path: '/advanced/:stepRouteSlug?/:childStepRouteSlug?',
        name: DevRouteName.DEV_ADVANCED_SETTINGS,
        props: true,
        component: () => import('../../../components/specific/dev/AdvancedSettings/AdvancedSettings.vue.js'),
        meta: {
            noPortal: true,
        },
    },
    {
        path: '/test',
        name: DevRouteName.DEV_TEST_TOOLING,
        props: true,
        component: () => import('../../../components/specific/dev/TestTooling.vue.js'),
        meta: {
            devOnly: true,
            noPortal: true,
        },
    },
];
/**
 * RootState must be passed as type param.
 *
 * Example: `getRoutesDev<RootState>()`
 *
 * RootState is type-checked to ensure the routes cannot be added to an app that
 * does not have the necessary vuex modules set up.
 */
const getRoutesDev = () => routesDev;

export { getRoutesDev };
